import { render, staticRenderFns } from "./AddOrEditDomain.vue?vue&type=template&id=fcc7490e&scoped=true&"
import script from "./AddOrEditDomain.vue?vue&type=script&lang=js&"
export * from "./AddOrEditDomain.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditDomain.vue?vue&type=style&index=0&id=fcc7490e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc7490e",
  null
  
)

export default component.exports